// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Gj-z","breadcrumbItem":"Hj-z","hideOnMobile":"Ij-z"};